import React from 'react'

const MediumBusinessIcon = ({selected}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="26" viewBox="0 0 38 26" fill="none">
  <rect x="14.5" y="5.66699" width="22" height="19.3333" rx="1" stroke={selected ? "#207C97" :  "currentColor"} strokeWidth="2"/>
  <rect x="1.5" y="1" width="13" height="24" rx="1" stroke={selected ? "#207C97" :  "currentColor"} strokeWidth="2"/>
  <rect x="28.5" y="25" width="8" height="5" rx="1" transform="rotate(-90 28.5 25)" stroke={selected ? "#207C97" :  "currentColor"} strokeWidth="2"/>
  <rect x="17.5" y="13" width="4" height="4" rx="1" transform="rotate(-90 17.5 13)" stroke={selected ? "#207C97" :  "currentColor"} strokeWidth="2"/>
  <rect x="4.5" y="8" width="4" height="4" rx="1" transform="rotate(-90 4.5 8)" stroke={selected ? "#207C97" :  "currentColor"} strokeWidth="2"/>
  <rect x="4.5" y="15" width="4" height="4" rx="1" transform="rotate(-90 4.5 15)" stroke={selected ? "#207C97" :  "currentColor"} strokeWidth="2"/>
  <rect x="4.5" y="22" width="4" height="4" rx="1" transform="rotate(-90 4.5 22)" stroke={selected ? "#207C97" :  "currentColor"} strokeWidth="2"/>
  <rect x="24.5" y="13" width="4" height="4" rx="1" transform="rotate(-90 24.5 13)" stroke={selected ? "#207C97" :  "currentColor"} strokeWidth="2"/>
</svg>
  )
}

export default MediumBusinessIcon